module.exports = __webpack_public_path__ + "img/colaboracao1.5b62f3db.png";